const setHousePriceForSection2 = (payload) => {
  return {
    type: "setHousePriceForSection2",
    payload,
  };
};
export default setHousePriceForSection2;
